import session from '../../app/session'

export const deletePermission = (row) => {
  return (
    !!row
    && !!row.id
    && (row.id !== session.getUserId())
  ) ? session.hasClientPermission() : false;
};
